import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { PerformanceCategoriesSupport } from '../../enums/performance-categories-support.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'performanceCategoriesSupport',
  standalone: false
})
export class PerformanceCategoriesSupportPipe implements PipeTransform {
  public transform(value: PerformanceCategoriesSupport): string {
    return getPerformanceCategoriesSupport(value);
  }
}

export function getPerformanceCategoriesSupport(value: PerformanceCategoriesSupport): string {
  switch (value) {
    case PerformanceCategoriesSupport.None:
      return 'None';
    case PerformanceCategoriesSupport.Summary:
      return 'Summary';
    case PerformanceCategoriesSupport.Collecting:
      return 'Collecting';
    default:
      throw new Error(`Unsupported value for PerformanceCategoriesSupport: ${value}.`);
  }
}

export function getPerformanceCategoriesSupportList(): IdName[] {
  return enumToList(PerformanceCategoriesSupport, getPerformanceCategoriesSupport);
}

export function getPePerformanceCategoriesSupportList(): IdName[] {
  return getPerformanceCategoriesSupportList().filter((x) => x.id !== PerformanceCategoriesSupport.Summary);
}
